module.exports = {"id":"1a7b097d-da39-45a1-859b-d118f2a910a2","name":"director-information","section":"Director Information","dependencies":{"items":[{"name":"business-information_type","value":"corp","operator":"equal"}]},"items":[{"name":"director-information_directors","props":{"headers":[{"text":"Name","value":"full-name"}],"newItemLabel":"Add A Director","noDataLabel":"Please Add A Director","required":true,"structure":{"id":"3f2717f5-8040-4d9a-92c0-362b76f7713f"}},"text":"Do you have elected directors?","type":"data-table"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/entity-maintenance-program/valuation-data/directorInformation.json
// module id = +Tiv
// module chunks = 0